var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-template',{attrs:{"loading":_vm.loading}},[_c('span',{staticClass:"f4 text-primary lh-copy"},[_vm._v(" Выполняется вход в систему... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }